import { useEffect } from "react";

const SITE_NAME = "91漫画";
const BASE_URL = "https://panelset.github.io";

/**
 * Updates the document title, meta description, canonical URL and OpenGraph tags
 * for a given page. Each page should call this once on mount.
 */
export default function useSeo(opts: {
  title: string;
  description: string;
  keywords?: string;
  path?: string;
}) {
  useEffect(() => {
    const fullTitle = opts.title
      ? `${opts.title} - ${SITE_NAME}`
      : `${SITE_NAME} - 漫画分类浏览、人气榜、热门推荐、完结榜与新作`;

    document.title = fullTitle;

    let metaDesc = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = opts.description;

    if (opts.keywords) {
      let metaKw = document.querySelector<HTMLMetaElement>('meta[name="keywords"]');
      if (!metaKw) {
        metaKw = document.createElement("meta");
        metaKw.name = "keywords";
        document.head.appendChild(metaKw);
      }
      metaKw.content = opts.keywords;
    }

    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    const path = opts.path || "/";
    canonical.href = `${BASE_URL}${path}`;

    let ogUrl = document.querySelector<HTMLMetaElement>('meta[property="og:url"]');
    if (!ogUrl) {
      ogUrl = document.createElement("meta");
      ogUrl.setAttribute("property", "og:url");
      document.head.appendChild(ogUrl);
    }
    ogUrl.content = `${BASE_URL}${path}`;
  }, [opts.title, opts.description, opts.keywords, opts.path]);
}